import * as R from 'ramda';

export const buildRowGetter = (queryNode) =>
  R.compose(R.map(R.prop('node')), R.path([queryNode, 'edges']));

export const buildPageInfoGetter = (queryNode) =>
  R.path([queryNode, 'pageInfo']);
